<template>
  <section class="list">
    <Table :loading="isLoading" stripe border :columns="columns" :data="data">
      <template slot-scope="{ row, index }" slot="action">
       <span class="action" @click="handleClickDel(row.id)">[删除]</span>
      </template>
    </Table>
    <div class="page">
      <Page @on-change="onPageChange" :total="total" show-total  />
    </div>
  </section>
</template>

<script>
export default {
  props: ['data', 'total', 'isLoading'],
  data() {
    return {
      columns: [
        {
          title: "序号",
          type: 'index'
        },
        // {
        //   title: "部门名称",
        //   key: "deptName"
        // },
        {
          title: "管理员",
          key: "userName"
        },
        {
          title: "手机号码",
          key: "phoneNO"
        },
        {
          title: "操作",
          slot: "action",
      
        }
      ]
    };
  },
  methods: {
    onPageChange(e){
      this.$emit('onPageChange', e)
    },
    handleClickDel(id) {
      this.$emit('onClickDel', id)
    }
  }
};
</script>

<style  scoped lang="less">
.list {
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #dddddd;
  .page {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
}
.action{
  color: #5e6d94;
  cursor: pointer;
  margin-right: 10px;
}
</style>